import { render, staticRenderFns } from "./boards-dropdown.vue?vue&type=template&id=3c3bdbc3"
import script from "./boards-dropdown.vue?vue&type=script&lang=js"
export * from "./boards-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports